
const homepage = {
  // Hero section
  'hero.headline': 'Elite Trading. Jetzt für alle zugänglich.',
  'hero.subheadline': 'Professionelle Anlagestrategien, die einst Institutionen vorbehalten waren — jetzt für Privatanleger über The Club verfügbar',
  'hero.cta.join': 'The Club beitreten',
  'hero.cta.track': 'Unsere Performance verfolgen',
  
  // What is The Club section
  'whatIs.header': 'Was ist The Club?',
  'whatIs.subtitle': 'Professionelles Trading, neu definiert für Sie',
  'whatIs.copy': 'Bei The Club gestalten wir die Finanzlandschaft neu. Unsere Mission ist einfach: Elite-Handelsstrategien auf institutionellem Niveau für Privatanleger zugänglich zu machen — mit Transparenz, Performance und Vertrauen im Kern. Ein nachhaltiges, langfristiges Geschäftsmodell anbieten, das es gewöhnlichen Menschen ermöglicht, an dem teilzunehmen, was einst eine exklusive Finanzwelt war. Wir sind hier, um den Zugang zur finanziellen Freiheit zu demokratisieren — einen Investor nach dem anderen.',
  'whatIs.cta': 'Das The Club Team kennenlernen',
  
  // Why Join section
  'whyJoin.header': 'Warum The Club beitreten?',
  'whyJoin.subtitle': 'Intelligentes, einfaches, kraftvolles Investieren',
  'whyJoin.copy': 'Unsere Plattform ermöglicht es Ihnen, Ihr Vermögen mit Vertrauen zu vermehren, geleitet von erstklassigen Experten, die Ihr Portfolio verwalten.',
  'whyJoin.feature1.title': 'Beginnen Sie mit nur $500',
  'whyJoin.feature1.desc': 'Keine Barrieren, keine Obergrenze — skalieren Sie nach Ihren Bedingungen',
  'whyJoin.feature2.title': 'Transparente Performance',
  'whyJoin.feature2.desc': 'Echtzeit-Zugang zu Ihren Portfolio-Metriken',
  'whyJoin.feature3.title': 'Professionelles Risikomanagement',
  'whyJoin.feature3.desc': 'Strategien zum Schutz und Wachstum Ihres Kapitals',
  'whyJoin.feature4.title': 'Globaler Support',
  'whyJoin.feature4.desc': 'Unser Team ist da — in Ihrer Sprache, in Ihrer Region',
  'whyJoin.cta': 'Jetzt investieren',
  
  // Trusted Broker section
  'broker.header': 'Vertrauenswürdiger Broker',
  'broker.subtitle': 'Ihr Kapital verdient ein sicheres Zuhause',
  'broker.copy': 'Sicherheit und Transparenz sind wichtig. Deshalb arbeiten wir ausschließlich mit Radex Markets, einem regulierten Broker mit Lizenz der Seychelles Financial Services Authority (FSA). Radex priorisiert den Kundenschutz durch die Implementierung robuster Sicherheitsprotokolle zum Schutz sowohl der Kundenmittel als auch der persönlichen Daten. Es bietet modernste Technologie und eine wettbewerbsfähige Handelsumgebung, die darauf ausgelegt ist, die Bedürfnisse moderner Trader zu erfüllen.',
  'broker.cta': 'Mehr über unseren Broker erfahren',
  'broker.badge1': 'Sichere Verarbeitung',
  'broker.badge2': 'FSA reguliert',
  'broker.badge3': 'Fondssicherheit',
  'broker.badge4': 'Transparente Operationen',
  
  // Meet Traders section
  'traders.header': 'Lernen Sie unsere Trader kennen',
  'traders.subtitle': 'Echte Expertise. Bewährte Strategien.',
  'traders.copy': 'Unser Trading-Team bringt über 16 Jahre Erfahrung in der Entwicklung institutioneller algorithmischer Strategien seit 2009 mit. Mit einem tiefen Verständnis der globalen Märkte wissen sie, wie sie sich anpassen und performen — unabhängig von den Bedingungen. Einige unserer Profis haben sogar in den Top 5 im Vereinigten Königreich auf Plattformen wie Pelican Asset Management gestanden. Mit einem unerbittlichen Fokus auf niedrige Drawdowns und strenge Risikokontrolle sind sie jetzt für Sie zugänglich, um Ergebnisse zu liefern.',
  'traders.stats.experience': '16+',
  'traders.stats.experienceLabel': 'Jahre Erfahrung',
  'traders.stats.rank': 'Top 5',
  'traders.stats.rankLabel': 'UK Trading Ranking',
  'traders.stats.since': 'Seit 2009',
  'traders.stats.sinceLabel': 'Strategieentwicklung',
  'traders.approach.algorithmic.title': 'Algorithmischer Ansatz',
  'traders.approach.algorithmic.point1': 'Datengetriebene Entscheidungsfindung',
  'traders.approach.algorithmic.point2': 'Rückgetestete Strategien seit 2009',
  'traders.approach.algorithmic.point3': 'Risikomanagement-Parameter',
  'traders.approach.risk.title': 'Risikokontrolle',
  'traders.approach.risk.point1': 'Fokus auf niedrige Drawdowns',
  'traders.approach.risk.point2': 'Strenge Positionsgrößenregeln',
  'traders.approach.risk.point3': 'Adaptiver Marktansatz',
  
  // Performance section
  'performance.header': 'The Club Performance',
  'performance.subtitle': 'Sehen Sie unsere Trader in Aktion',
  'performance.recentPerformance': 'Aktuelle Performance',
  'performance.monthlyPerformance': 'Monatliche Performance',
  'performance.yearlyPerformance': 'Jährliche Projektion',
  'performance.maxDrawdown': 'Max Drawdown',
  'performance.winRate': 'Gewinnrate',
  'performance.cta': 'Institutional Strategy auf FX Blue verfolgen',
  'performance.tagline': 'Spitzenleistung. Minimaler Drawdown. 100% Transparenz.',
  'performance.myfxbooktext': 'Performance wie keine andere, validiert durch FX Blue',
  'performance.institutional': 'Institutionelle Strategie',
  'performance.spartanAi': 'Spartan AI',
  'performance.ctaSpartan': 'Spartan AI auf Myfxbook verfolgen',
  'performance.myfxbookTextSpartan': 'Performance validiert durch Myfxbook',
  'performance.recentPerformanceInstitutional': 'Institutional Strategy Performance',
  'performance.recentPerformanceSpartan': 'Spartan AI Performance',
  'performance.strategiesCta': 'Erfahren Sie Mehr Über Unsere Strategien',
  
  // How it works section
  'howItWorks.header': 'Wie es funktioniert',
  'howItWorks.subtitle': 'Einfache Regeln. Klare Belohnungen.',
  'howItWorks.feature1.title': 'Beitreten mit nur $500',
  'howItWorks.feature1.desc': 'Klein anfangen, jederzeit skalieren — keine maximalen Limits',
  'howItWorks.feature2.title': 'Keine Mitgliedsgebühr',
  'howItWorks.feature2.desc': 'Nur für kurze Zeit: Die 20% Gebühr entfällt. Investiere mit TheClub und verdiene ab dem ersten Tag',
  'howItWorks.feature3.title': 'Ausgerichtete Anreize',
  'howItWorks.feature3.desc': 'Eine 50% Performance-Gebühr — wir gewinnen nur, wenn Sie gewinnen',
  'howItWorks.feature4.title': 'Jederzeit abheben',
  'howItWorks.feature4.desc': 'Vollzugang zu Kapital und Gewinnen — keine Sperrfristen',
  'howItWorks.feature5.title': 'Ein- und Auszahlungsmethoden',
  'howItWorks.feature5.desc': 'Visa, Mastercard, Banküberweisung und Krypto — schnell und flexibel',
  'howItWorks.feature6.title': 'KYC & AML Compliance',
  'howItWorks.feature6.desc': 'Ihre Sicherheit und regulatorisches Vertrauen sind unsere Prioritäten',
  'howItWorks.cta': 'The Club beitreten',
  'howItWorks.calculator.title': 'Sehen Sie Ihr Wachstumspotential mit Zinseszins',
  'howItWorks.calculator.results': 'Ergebnisse:',
  'howItWorks.calculator.totalInvestment': 'Gesamtinvestition ($)',
  'howItWorks.calculator.investment': 'Investition ($)',
  'howItWorks.calculator.membership': 'Mitgliedschaftsgebühr ($)',
  'howItWorks.calculator.monthlyRate': 'Monatlicher Zinssatz (%)',
  'howItWorks.calculator.fiftymonthlyRate': '50% Monatlicher Zinssatz (%)',
  'howItWorks.calculator.variationRate': 'Monatliche Variationsrate (%)',
  'howItWorks.calculator.years': 'Investitionszeit (Jahre)',
  'howItWorks.calculator.calculate': 'Berechnen',
'howItWorks.calculator.simpleInvestment': 'Zukünftiger Wert mit monatlicher Auszahlung',
'howItWorks.calculator.compoundInvestment': 'Zukünftiger Wert mit Zinseszins',
'howItWorks.calculator.difference': 'Differenz',
  'howItWorks.calculator.monthAbbr': 'M',
  'howItWorks.calculator.yearAbbr': 'J',
  'howItWorks.calculator.month': 'Monat',
  'howItWorks.calculator.year': 'Jahr',
  
  // Team section
  'team.header': 'Lernen Sie unser Team kennen',
  'team.subtitle': 'The Club wird von Visionären angetrieben',
  'team.text': 'Lernen Sie die Köpfe kennen, die The Clubs Mission formen und globale finanzielle Freiheit durch Transparenz, Integrität und hohe Performance fördern — Investieren für alle zugänglich machen.',
  'team.member1': 'Gianluca N. – Leiter Neue Marktentwicklung',
  'team.member2': 'Samuel N. – Leiter Marketing',
  'team.member3': 'Marco M. – Brokerage-Berater\n(Leiter Italien\n bei Radex Markets)',
  'team.member4': 'Lloyd S. – Chief Trading Officer',
  'team.member5': 'Horacio A. – Leitender \nTechnologieberater',
  
  // Global Presence section
  'global.header': 'Globale Präsenz',
  'global.subtitle': 'Lokale Gesichter. Globale Reichweite.',
  'global.text': 'Ob Sie in Italien, Deutschland, dem Nahen Osten oder Lateinamerika sind, wir sind hier mit lokalem Support — in Ihrer Sprache und in Ihrer Zeitzone.',
  'global.contact1': 'Germano M. – Vertreter Der Italienischen Sprache',
  'global.contact2': 'Manuel G. – Vertreter Der Deutschen Sprache',
  'global.contact3': 'Horacio A. – Vertreter Der Spanischen Sprache',
  'global.contact4': 'Aisha R. – Vertreter Der Englischen Sprache',
  'global.contact5': 'XXX XXXX – Vertreter Der Französischen Und Arabischen Sprachen',
  'global.tagline': 'Möchten Sie Ihre eigene Community mit The Club aufbauen? Sprechen Sie direkt mit einem unserer Vertreter.',
  
  // Referral section
  'referral.header': 'Empfehlungsprogramm',
  'referral.subtitle': 'Verdienen Sie beim Aufbau Ihrer Community',
  'referral.text': 'Teilen Sie die Möglichkeit. Bauen Sie Ihr Einkommen auf.',
  'referral.copy.default': 'Als Partner von The Club können Sie nicht nur mit Ihren Investitionen verdienen, sondern auch anderen helfen, ihr Einkommen zu steigern. Unser 10-Ebenen-Vergütungsplan ermöglicht Ihnen den Aufbau eines langfristigen passiven Einkommens — mit Provisionszahlungen, die für den 10. jedes Monats geplant sind.',
  'referral.copy.alternate': 'Als Partner von The Club können Sie nicht nur mit Ihren Investitionen verdienen, sondern auch anderen helfen, ihr Einkommen zu steigern. Unser 5-Ebenen-Vergütungsplan ermöglicht Ihnen den Aufbau eines langfristigen passiven Einkommens — mit Provisionszahlungen, die für den 10. jedes Monats geplant sind.',
  'referral.table.level': 'Stufe',
  'referral.table.commission': 'Provision',
  'referral.table.levelNumber': 'Stufe {level}',
  'referral.structure.title': 'Stufenstruktur',
  'referral.commission.title': 'Vergütungsplan - Erziele Dein Passives Einkommen!',
  'referral.commission.description.default': 'Der Vergütungsplan zahlt bis zu 20% (kombiniert) auf die ersten 10 Ebenen der Tiefe basierend auf den monatlich von Kunden generierten Gewinnen. Dies gibt jedem Affiliate die Möglichkeit, ein reales und wachsendes monatliches Einkommen dank des Zinseszinseffekts zu erzielen, der es jedem Affiliate ermöglicht, sein Kundenportfolio im Laufe der Zeit wachsen zu sehen, unterstützt durch die hohe Performance unserer Trading-Strategien.',
  'referral.commission.description.alternate': 'Der Vergütungsplan zahlt bis zu 12% (kombiniert) auf die ersten 5 Ebenen der Tiefe basierend auf den monatlich von Kunden generierten Gewinnen. Dies gibt jedem Affiliate die Möglichkeit, ein reales und wachsendes monatliches Einkommen dank des Zinseszinseffekts zu erzielen, der es jedem Affiliate ermöglicht, sein Kundenportfolio im Laufe der Zeit wachsen zu sehen, unterstützt durch die hohe Performance unserer Trading-Strategien.',
  'referral.example.title': 'Beispielszenario',
  'referral.example.text': 'Wenn Sie 3 Personen empfehlen, die jeweils $1.000 investieren, und jede von ihnen 2 weitere Personen empfiehlt, verdienen Sie Provisionen von allen 9 Personen in Ihrer Community — was einen mächtigen passiven Einkommensstrom schafft.',
  
  // New ReferralSection keys
  'referral.you': 'Sie',
  'referral.level1Commission': 'Stufe 1: 5% Provision',
  'referral.directReferral': 'Direkte Empfehlung',
  'referral.levels2to4Commission': 'Stufen 2-4: 3% Provision',
  'referral.levels5to6Commission': 'Stufen 5-6: Je 2% Provision',
  'referral.level7Commission': 'Stufe 7: 1%',
  'referral.level8Commission': 'Stufe 8: 0,5%',
  'referral.level9Commission': 'Stufe 9: 0,3%',
  'referral.level10Commission': 'Stufe 10: 0,2%',
  'referral.communityExpands': 'Ihre Community erweitert sich tiefer und verdient Ihnen Provisionen bis zu {maxLevels} Stufen',
  'referral.earnCommissions.default': 'Der Vergütungsplan basiert auf einer UNILEVEL-Struktur, die bis zu 10 Ebenen tief auszahlt. Unsere Struktur belohnt Sie für den Aufbau einer starken Community.',
  'referral.earnCommissions.alternate': 'Der Vergütungsplan basiert auf einer UNILEVEL-Struktur, die bis zu 5 Ebenen tief auszahlt. Unsere Struktur belohnt Sie für den Aufbau einer starken Community.',
  'referral.levelSuffix': 'Stufe',
  
  // Events section
  'events.header': 'Events & Community',
  'events.subtitle': 'Ein Club, der verbindet',
  'events.text': 'Nehmen Sie an Webinaren teil, treffen Sie andere Investoren und seien Sie Teil von etwas Größerem. Sehen Sie, was passiert — online und persönlich.',
  'events.event1': 'Events kommen bald',
  'events.event2': 'Events kommen bald',
  'events.event3': 'Events kommen bald',
  'events.communityHighlights': 'Community-Highlights',
  'events.weeklyStrategySessions': 'Wöchentliche Strategiesitzungen',
  'events.weeklyStrategySessionsDesc': 'Schließen Sie sich unseren Experten bei der Analyse von Marktchancen an',
  'events.investorInterviews': 'Investor-Interviews',
  'events.investorInterviewsDesc': 'Hören Sie Erfolgsgeschichten aus unserer wachsenden Community',
  'events.educationalResources': 'Bildungsressourcen',
  'events.tradingFundamentals': 'Trading-Grundlagen',
  'events.tradingFundamentalsDesc': 'Kostenlose Leitfäden zum Verständnis des Tradings',
  'events.expertWebinars': 'Experten-Webinare',
  'events.expertWebinarsDesc': 'Fortgeschrittene Themen für erfahrene Benutzer',
  
  // Connect section
  'connect.header': 'Bleiben Sie verbunden',
  'connect.subtitle': 'Bleiben wir in Kontakt',
  'connect.whatsapp': 'Kontaktieren Sie uns über WhatsApp',
  'connect.language.english': 'English',
  'connect.language.italian': 'Italiano',
  'connect.language.spanish': 'Español',
  'connect.language.german': 'Deutsch',
  'connect.language.croatian': 'Hrvatski',
  'connect.language.turkish': 'Türkçe',
  'connect.language.french': 'Français',
  'connect.language.arabic': 'العربية',
  
  // Footer section
  'footer.rights': 'Alle Rechte vorbehalten.',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.privacy': 'Datenschutzrichtlinie',
  'footer.cookies': 'Cookies',
  'footer.contactMe': 'Kontaktiere mich',
  
  // Strategies page
  //'strategies.heroSubtitle': 'Zwei Strategien. Eine Vision. Maximaler Schutz & Wachstum.',
  'strategies.pageTitle': 'TheClub Strategien',
  'strategies.heroSubtitle': 'Eine Vision. Maximaler Schutz & Wachstum.',
  'strategies.learnMore': 'Mehr erfahren',
  'strategies.showLess': 'Weniger anzeigen',

  // Institutional Strategy
  'strategies.institutional.tagline': 'Präzision. Stabilität. Institutioneller Schutz.',
  'strategies.institutional.highlight1': '16 Jahre Erfahrung',
  'strategies.institutional.highlight1Desc': 'Britische institutionelle Trader mit Hedge-Fonds- und Deutsche Bank-Hintergrund',
  'strategies.institutional.highlight2': 'Fokus auf Gold & GU',
  'strategies.institutional.highlight2Desc': 'Mittel-/Hochfrequenz-Algorithmen auf Gold und Pfund/Dollar',
  'strategies.institutional.highlight3': '5–6% Monatliches Ziel',
  'strategies.institutional.highlight3Desc': 'Konstante Renditen mit einem Durchschnitt von 35–40% jährlich',
  'strategies.institutional.highlight4': 'Kontrolliertes Risiko',
  'strategies.institutional.highlight4Desc': 'Konservativer Ansatz mit Priorität auf Kapitalerhalt',
  'strategies.institutional.description': 'Es ist eine Strategie, die direkt von unseren britischen institutionellen Tradern verwaltet wird, einer Arbeitsgruppe, die seit 16 Jahren an den Finanzmärkten tätig ist. Sie haben mit einem der wichtigsten Hedge-Fonds im Vereinigten Königreich sowie mit Deutsche Bank zusammengearbeitet. Sie sind spezialisiert auf die Erstellung und kontinuierliche Aktualisierung von Algorithmen, die mit mittlerer/hoher Frequenz hauptsächlich auf Gold und GU (Pfund/Dollar) operieren. Es ist eine Strategie, die darauf abzielt, durchschnittlich 5–6% pro Monat zu erzielen, wie bereits im ersten Jahr mit The Club erreicht, bei gleichzeitig relativ kontrolliertem Risiko, um dem Kunden durchschnittlich etwa 35–40% jährlich zu bieten.',

  // Spartan AI Strategy
  'strategies.spartanAi.tagline': 'Aggressiv. Intelligent. Spartan-Level Performance.',
  'strategies.spartanAi.highlight1': 'AI-gesteuert',
  'strategies.spartanAi.highlight1Desc': 'Kontinuierlich aktualisierte künstliche Intelligenz von italienischen Tradern',
  'strategies.spartanAi.highlight2': 'Intraday Gold',
  'strategies.spartanAi.highlight2Desc': 'Semi-manuelle Strategie, die AI-Operationen mit manuellen Trades kombiniert',
  'strategies.spartanAi.highlight3': 'Höheres Gewinnpotenzial',
  'strategies.spartanAi.highlight3Desc': 'Aggressiverer Ansatz mit überlegenen Renditen',
  'strategies.spartanAi.highlight4': '20% Equity Stop',
  'strategies.spartanAi.highlight4Desc': 'Maximaler Verlustschutz gedeckt durch Institutional Strategy Gewinne',
  'strategies.spartanAi.description': 'Es ist eine künstliche Intelligenz, die von unserer Gruppe italienischer Trader erstellt und kontinuierlich aktualisiert wird, die seit 6 Jahren professionell in der Trading-Welt mit hervorragenden Ergebnissen tätig sind. Es ist eine aggressivere Strategie, die semi-manuell arbeitet: Die Trader selbst operieren, indem sie die Operationen der AI mit ihren eigenen manuellen Trades kombinieren. Sie arbeitet intraday ausschließlich auf Gold. Es ist eine Strategie, die tendenziell viel höhere Gewinne generiert, aber gleichzeitig einen Equity Stop von 20% hat. Das bedeutet, dass der Kunde niemals mehr als 20% des in Spartan AI investierten Kapitals verlieren kann; dieses Kapital ist durch die Institutional Strategy mit ihren Gewinnen gedeckt, falls einmal im Jahr dieser Equity Stop erreicht wird.',

  // Strategy Bond (50/50)
  'strategies.bond.title': 'Gemeinsam Stärker: Der 50/50-Ansatz',
  'strategies.bond.description': 'Jede Einzahlung wird strategisch 50/50 auf beide Strategien aufgeteilt. Die Institutional Strategy bietet eine stabile, konservative Grundlage, die Ihr Kapital schützt, während Spartan AI aggressives Wachstumspotenzial liefert. Im seltenen Fall, dass Spartan AI seinen 20% Equity Stop erreicht, dienen die konstanten Gewinne der Institutional Strategy als Sicherheitsnetz — und stellen sicher, dass Ihre Gesamtinvestition geschützt bleibt und wächst.',
  'strategies.bond.benefit1': 'Maximaler Schutz',
  'strategies.bond.benefit1Desc': 'Institutional Strategy Gewinne schützen vor Spartan AI Equity Stops',
  'strategies.bond.benefit2': 'Intelligente Diversifikation',
  'strategies.bond.benefit2Desc': 'Zwei unterschiedliche Ansätze reduzieren das Gesamtportfoliorisiko',
  'strategies.bond.benefit3': 'Optimiertes Wachstum',
  'strategies.bond.benefit3Desc': 'Konservative Stabilität trifft auf aggressives Gewinnpotenzial',

  // Floating button
  'floatingButton.embassador.title': 'Werde ein The Club Botschafter',
  'floatingButton.embassador.text': 'Tritt unserem Empfehlungsprogramm bei und verdiene fantastische Provisionen, während du anderen hilfst, finanzielle Freiheit zu erreichen. Kontaktiere uns über WhatsApp, um noch heute deine Reise als The Club Botschafter zu beginnen!',
  'floatingButton.embassador.button': 'Werde ein The Club Botschafter',
  'floatingButton.embassador.contact': 'Verbinde dich mit einem Vertreter',
  'floatingButton.embassador.feature1': 'Baue deine Community auf',
  'floatingButton.embassador.feature2': 'Verdiene Provisionen auf bis zu {maxLevels} Ebenen',
  'floatingButton.embassador.feature3': 'Pünktliche Zahlungen, geplant für den 15. eines jeden Monats',
};

export default homepage;
